import { render, staticRenderFns } from "./ListarRegistrosEstudante.vue?vue&type=template&id=f877c2d2&scoped=true&"
import script from "./ListarRegistrosEstudante.vue?vue&type=script&lang=js&"
export * from "./ListarRegistrosEstudante.vue?vue&type=script&lang=js&"
import style0 from "./ListarRegistrosEstudante.vue?vue&type=style&index=0&id=f877c2d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f877c2d2",
  null
  
)

export default component.exports